import React from 'react';
import MediaQuery from 'react-responsive';

import { SuccessTickIcon } from '@nw/shared/ui';

import { EmbeddedFormSuccessMessageProps } from '../../types/MultiStepRegistrationFormTypes';

import {
  IconContainer,
  LineBreak,
  SuccessDescription,
  SuccessHeading,
  SuccessMessageContainer
} from './styledComponents';

export const EmbeddedFormSuccessMessage: React.FC<
  EmbeddedFormSuccessMessageProps
> = ({ title, description, customClassNames }) => {
  return (
    <SuccessMessageContainer
      className={customClassNames.embeddedFormSuccessMessageContainer}
    >
      <IconContainer>
        <MediaQuery maxWidth={768}>
          <SuccessTickIcon height={48} width={48} />
        </MediaQuery>
        <MediaQuery minWidth={769}>
          <SuccessTickIcon height={74} width={74} />
        </MediaQuery>
      </IconContainer>
      <SuccessHeading
        className="step-info-title"
        dangerouslySetInnerHTML={{
          __html: title
        }}
      />
      <LineBreak
        className={customClassNames.embeddedFormSuccessMessageLineBreak}
      />
      <SuccessDescription
        dangerouslySetInnerHTML={{
          __html: description
        }}
        className={customClassNames.embeddedFormSuccessMessageDescription}
      />
    </SuccessMessageContainer>
  );
};
